// extracted by mini-css-extract-plugin
export var text = "_72-0";